import React from 'react';
import styles from "./Footer.module.css";

// A simple social icon component
const SocialIcon = ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
        {children}
    </a>
);

export const Footer = () => {
    return (
        <footer className={styles.footerContainer}>
            <div className={styles.footerContent}>
                <div className={styles.socialLinks}>
                    {/* Placeholder SVG for LinkedIn */}
                    <SocialIcon href="https://www.linkedin.com/company/cirkitexsemi/">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                    </SocialIcon>
                     {/* Placeholder SVG for Twitter/X */}
                    <SocialIcon href="#">
                       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </SocialIcon>
                     {/* Placeholder SVG for a generic website/portfolio */}
                    <SocialIcon href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72"></path></svg>
                    </SocialIcon>
                </div>
                <p className={styles.copyright}>
                    © 2025 Cirkitex Semiconductor. All rights reserved.
                </p>
                <p className={styles.tagline}>
                    Together, let’s shape the future of technology.
                </p>
            </div>
        </footer>
    )
}
